import { PageHeader } from '@app/components/layout/page/components/page-header';
import Page from '@app/components/layout/page/page';
import { Icons } from '@shared/components/content/icons';
import { PageTabs } from '@shared/components/page-tabs';
import { Button } from '@shared/components/ui/button';
import { generatePath, Outlet, useNavigate } from 'react-router-dom';
import { soldGoodsRoutes } from '../sold-goods-routes';
import { getPackagingReferrerLabel } from '../utils';
import { useSoldPackagingItem } from './sold-packaging-item-context';
import { useSoldPackagingItemsTabs } from './tabs';

export default function SoldPackagingItemLayout() {
  const { item, status, referrer } = useSoldPackagingItem();
  const tabs = useSoldPackagingItemsTabs();
  const navigate = useNavigate();

  return (
    <Page
      name={item?.packagingName}
      page="layout"
      status={status}
      title={`${item?.packagingName} - Sold Packaging`}
      flexFullHeight
    >
      <PageHeader
        name={item?.packagingName}
        tabs={<PageTabs tabs={tabs} />}
        breadcrumbs={[
          {
            label: 'Sold goods',
            url: generatePath(soldGoodsRoutes.SOLD_PACKAGING),
          },
          {
            label: 'Packaging',
            url: generatePath(soldGoodsRoutes.SOLD_PACKAGING),
          },
          {
            label: item?.packagingName || 'Item',
            url: generatePath(soldGoodsRoutes.SOLD_PACKAGING_ITEM, {
              item_uuid: item?.uuid || '',
            }),
          },
        ]}
        toolbar={
          referrer ? (
            <Button
              variant="ghost"
              onClick={() => navigate(referrer)}
              icon={<Icons.chevronLeft className="size-4" />}
            >
              {getPackagingReferrerLabel(referrer)}
            </Button>
          ) : undefined
        }
      />
      <Outlet />
    </Page>
  );
}
